module.exports = __webpack_public_path__ + "img/Bubalo.b2e6cbf8.jpg";